import script from "./MediaList.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaList.vue?vue&type=script&setup=true&lang=js"

import "./MediaList.vue?vue&type=style&index=0&id=04d40736&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d40736"]])

export default __exports__